/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this),
    );

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });

    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    this.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*",
      );
    });
    this.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    this.querySelectorAll("video").forEach((video) => video.pause());
  }
}
customElements.define("modal-dialog", ModalDialog);

/**
 *  @class
 *  @function ModalFBT
 */
class ModalFBT extends ModalDialog {
  constructor() {
    super();

    // Elements
    this.continueButton = this.querySelector('.continue');

    this.initEvents();
    //this.setAttribute('open', '');
  }

  initEvents() {
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-FBT") this.hide();
    });

    if (this.continueButton) {
      this.continueButton.addEventListener('click', (e) => {
        console.log('event:', e);

        this.hide();
      });
    }
  }
}
customElements.define("modal-fbt", ModalFBT);

/**
 *  @class
 *  @function ModalViewMoreProducts
 */
class ModalViewMoreProducts extends ModalDialog {
  constructor() {
    super();

    this.itemKey = this.dataset.itemKey;

    // Elements
    this.modalContent = document.querySelector('.popup-modal__content-info')
    this.continueButton = this.querySelector('.continue');
    this.cartCompatibleProducts = document.querySelector(`cart-compatible-products[data-item-key="${this.itemKey}"]`)
    this.productCards = this.querySelectorAll('.product-card');

    this.initEvents();

    //769
    //1026
  }

  initEvents() {
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-VIEW-MORE-PRODUCTS") this.hide();
    });

    if (this.continueButton) {
      this.continueButton.addEventListener('click', (e) => {
        console.log('event:', e);

        this.hide();
      });
    }

		if (this.cartCompatibleProducts) {
			this.productLimit = parseInt(this.cartCompatibleProducts.dataset.productLimit);
      if (this.productCards.length > 0) {
        this.productCards.forEach((productCard) => {
          this.modifyProductCard(productCard);
        })
      }
		}
  }

  modifyProductCard(productCard) {
    if (!productCard) return;

    const container = document.createElement('div');
    container.classList.add('info-column', 'flex-1');

    let innerContainer = productCard.querySelector('.product-card-image').parentNode;
    innerContainer.classList.remove('flex-col');
    innerContainer.appendChild(container);

    let productCardImage = innerContainer.querySelector('.product-card-image');
    productCardImage.classList.add('md:max-w-[270px]', 'mr-2');

    const classNames = ['product-card__name', 'card-price'];
    classNames.forEach((className) => {
      let ele = productCard.querySelector(`.${className}`);
      container.appendChild(ele);
    });

    this.modalContent.appendChild(productCard);
  }
}
customElements.define("modal-view-more-products", ModalViewMoreProducts);
